import { FeatureLoader } from 'oasis-os-react';
import * as React from 'react';
import { useNestedApps } from 'oasis-os-contentful';
import { readGlobal } from 'oasis-os-common';

const RootFeatures: React.FC = () => {
  const features = useNestedApps('rootFeatures');
  const hydrateEnabled: boolean = readGlobal(
    `$.global.value.functionalConfig.features.hydrate.enabled`,
  );

  return (
    <>
      {(features || []).map(({ name, meta, entry, ...rest }) => {
        if (meta.sharedModules) {
          return meta.sharedModules.map((module: string) => {
            return (
              <FeatureLoader
                key={`${name}-feature-${meta.contentId}-${module}`}
                name={name}
                app={{ name }}
                id={meta.contentId}
                initial={entry}
                sharedModule={module}
                hydrate={hydrateEnabled}
                {...rest}
                {...meta}
              />
            );
          });
        }
        return (
          <FeatureLoader
            key={`${name}-feature-${meta.contentId}`}
            name={name}
            app={{ name }}
            id={meta.contentId}
            initial={entry}
            hydrate={hydrateEnabled}
            {...rest}
            {...meta}
          />
        );
      })}
    </>
  );
};

export default RootFeatures;
